import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { selectActiveCompanyId } from "../../../redux/features/user/selectors/userState.selectors";
import { createEventDeliveryConfig } from "../actions/createEventDeliveryConfig";
import { deleteEventDeliveryConfig } from "../actions/deleteEventDeliveryConfig";
import { updateEventDeliveryConfig } from "../actions/updateEventDeliveryConfig";
import { ICreateEventDeliveryConfigPayload, IUpdateEventDeliveryConfigPayload } from "../interfaces";
import { EVENT_DELIVERY_CONFIG_QUERY_KEY } from "./useGetEventDeliveryConfig";

export const useCreateEventDeliveryConfig = () => {
  const queryClient = useQueryClient();
  const companyId = useSelector(selectActiveCompanyId);

  return useMutation({
    mutationFn: (payload: ICreateEventDeliveryConfigPayload) => createEventDeliveryConfig(payload),
    onSuccess: (data) => {
      queryClient.setQueryData([EVENT_DELIVERY_CONFIG_QUERY_KEY, companyId], data);
    },
  });
};

export const useUpdateEventDeliveryConfig = () => {
  const queryClient = useQueryClient();
  const companyId = useSelector(selectActiveCompanyId);

  return useMutation({
    mutationFn: (payload: IUpdateEventDeliveryConfigPayload) => updateEventDeliveryConfig(payload),
    onSuccess: (data) => {
      queryClient.setQueryData([EVENT_DELIVERY_CONFIG_QUERY_KEY, companyId], data);
    },
  });
};

export const useDeleteEventDeliveryConfig = () => {
  const queryClient = useQueryClient();
  const companyId = useSelector(selectActiveCompanyId);

  return useMutation({
    mutationFn: () => deleteEventDeliveryConfig(),
    onSuccess: () => {
      queryClient.setQueryData([EVENT_DELIVERY_CONFIG_QUERY_KEY, companyId], null);
    },
  });
};
